export const SET_FEATURES = 'AB_TESTING/SET_FEATURES';
export const INIT_AB_TEST = 'AB_TESTING/INIT_AB_TEST';
